import MessageRecipientItem from "./MessageRecipientItem";

export {MessageRecipientsList as default};

/**
* Message Recipients Item
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessageRecipientsList {
  /**
   * Message full from
   *
   * @public
   *
   * @type {MessageRecipientItem}
   *
   * @since 7.0.0
   */
  from = new MessageRecipientItem();

  /**
   * Message full to
   *
   * @public
   *
   * @type {Array<MessageRecipientItem}
   *
   * @since 7.0.0
   */
  to = [];

  /**
   * Nessage CCs
   *
   * @public
   *
   * @type {Array<MessageRecipientItem}
   *
   * @since 7.0.0
   */
  cc = [];

  /**
   * Nessage bccs
   *
   * @public
   *
   * @type {Array<MessageRecipientEntity}
   *
   * @since 7.0.0
   */
  bcc = [];

  /**
   * Recipients count excluding from
   *
   * @public
   *
   * @type {Number}
   *
   * @since 7.0.0
   */
  count = 0;
}